'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = require('./SvgIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/SvgIcon/index.js
// module id = 32
// module chunks = 35783957827783 114276838955818 231625713469023